import React, { useState } from 'react'
import { toast } from 'react-toastify'
import { v4 } from 'uuid'

import { TextInput } from '@peracto/peracto-editor-ui'
import removeExistingIds from '../../util/removeExistingIds'

import { CREATE, GET_LIST, useClient } from '@peracto/client'

const ContentBlockSave = ({ node, editor, getLibraryBlocks }) => {
    const [saving, setSaving] = useState(false)
    const [name, setName] = useState('')
    const { client } = useClient()

    const onSaveToTemplatesClick = async () => {
        setSaving(true)

        if (name) {
            try {
                const rawState = editor.plugins.serialize(node)
                const state = removeExistingIds(rawState)

                await client(CREATE, 'contents', {
                    data: {
                        title: name,
                        name: name,
                        type: 'template',
                        locale: 'en_GB',
                        body: [JSON.stringify([{ id: v4(), cells: [state] }])],
                    },
                    id: null,
                })

                setName('')
                getLibraryBlocks()

                toast.success(`Your new template item, "${name}", was saved`)
            } catch (e) {
                console.log(e)
                toast.error('There was an issue saving your template item')
            }
        } else {
            toast.warn('You need to set a name for your new template item')
        }

        setSaving(false)
    }

    return (
        <>
            <p>
                Set the contents of this block and use this to save it as a reusable block of
                content.
            </p>
            <TextInput label="Name" value={name} onChange={e => setName(e.target.value)} />
            <button
                className="btn btn-secondary"
                onClick={onSaveToTemplatesClick}
                disabled={saving}
            >
                Save to templates
            </button>
        </>
    )
}
export default ContentBlockSave
